document.addEventListener("click", function (event) {
    if (event.target.matches('.bss-b2b-customer-portal-share-cart-btn')) {
        event.preventDefault(); // Prevent any default or app behavior
        window.location.href = '/account?portal=/purchase-late'; // Your custom behavior
    }
});

document.addEventListener("DOMContentLoaded", function () {
  // Function to fetch and update the cart count
  function updateCartCount() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const cartCountElement = document.querySelector(".cart-count");
        if (cartCountElement) {
          if (cart.item_count > 0) {
            cartCountElement.textContent = cart.item_count; // Update the count
            cartCountElement.style.display = "inline-block"; // Show the count
          } else {
            cartCountElement.style.display = "none"; // Hide the count
          }
        }
      })
      .catch((error) => console.error("Error fetching cart data:", error));
  }

  // Call updateCartCount initially
  updateCartCount();

  // Observe DOM changes for potential cart updates (if the theme doesn’t trigger events)
  const cartObserver = new MutationObserver(updateCartCount);
  const cartContainer = document.querySelector(".site-header"); // Adjust selector if needed
  if (cartContainer) {
    cartObserver.observe(cartContainer, { childList: true, subtree: true });
  }

  // Fallback: Polling every few seconds (use only if needed)
  setInterval(updateCartCount, 2000); // Check every 5 seconds
});

document.addEventListener("DOMContentLoaded", function() {
    function setMinQuantity() {
        let qtyInput = document.querySelector('input[name="quantity_input"]');
        
        if (qtyInput) {
            let minQty = qtyInput.getAttribute("min"); // Get MinMaxify min value
            
            if (minQty && parseInt(minQty) > 1) {
                qtyInput.value = minQty; // Set default quantity to min value
            }
        }
    }

    // Run the function after a small delay to allow theme scripts to load
    setTimeout(setMinQuantity, 500);
});



document.addEventListener('DOMContentLoaded', function() {
  const quantityInputs = document.querySelectorAll('.quantity__input');

  quantityInputs.forEach(input => {
    input.addEventListener('change', () => {
      const key = input.dataset.key;   // Cart item key
      const quantity = input.value;    // Updated quantity

      // Shopify API for cart update
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates: {
            [key]: quantity
          }
        })
      }).then(response => response.json())
        .then(data => {
          // Update the cart counter badge (if available)
          const cartCountElement = document.querySelector('.cart-count-bubble');
          if (cartCountElement) {
            cartCountElement.textContent = data.item_count;
          }

          // Update the subtotal (without full page reload)
          updateCartTotals(data);

          // Persist the current quantity without resetting the input
          input.value = quantity;
        })
        .catch(error => {
          console.error('Error updating cart:', error);
        });
    });
  });
});
































